// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "index." + {"440":"0037b92d9c6a3b2085e1","581":"7ee01ae7754cb4d8f8db"}[chunkId] + ".js";
};